export default __webpack_public_path__ + "static/media/collapse-bg.30444f15.png";